import React, { useState } from 'react';
import axios from 'axios';
import LoadingView from '../components/LoadingView';
import { ep } from '../api/endpoints';


export default function WorkFlow() {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // --------------------------------------------------
  // 🔁 Loding view
  // --------------------------------------------------
  if (loading) {
    return <LoadingView message="読み込み中..." height="80vh" size={50} />;
  };


  // Firebase FunctionのURL（デプロイ地域に合わせて変更）
  const FUNCTION_URL = ep('get_salesforce_data');

  const handlePostRequest = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await axios.post(FUNCTION_URL, {
        name: 'ユーザー：タイラ',
        message: 'React.jsからのPOSTリクエストです',
        timestamp: new Date().toISOString(),
        page: 0,
        pageSize: 50
      });

      console.log('成功:', result.data);
      setResponse(result.data);

    } catch (err: any) {
      console.error('エラー詳細:', err);
      // バックエンドから返された詳細なエラーメッセージがあれば取得
      const errorData = err.response?.data;
      console.log('受信したエラーデータ:', errorData);
      if (errorData) {
        setResponse(errorData); // 詳細（スタックトレース等）をレスポンス欄に表示
        setError(errorData.error || err.message);
      } else {
        setError(err.message || 'エラーが発生しました');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Firebase Functions (Python) テスト</h2>

      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={handlePostRequest}
          disabled={loading}
          style={{ marginRight: '10px' }}
        >
          POSTリクエスト送信
        </button>

      </div>

      {loading && <p>送信中...</p>}

      {error && (
        <div style={{ color: 'red', marginTop: '10px', fontSize: '14px' }}>
          <strong>エラー:</strong> {error}
        </div>
      )}

      {response && (
        <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f0f0f0' }}>
          <h6>レスポンス内容:</h6>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontSize: '14px' }}>
            {typeof response === 'object' ? JSON.stringify(response, null, 2) : String(response)}
          </pre>
        </div>
      )}
    </div>
  );
}
